import { Injectable } from "@angular/core";

import { CommonState } from "../../state";

import { LogoutCooldownLimitState } from "./logout-cooldown-limit.model";

@Injectable({
	providedIn: "root",
})
export class LogoutCooldownLimitSelector {
	getLogoutCooldownLimit() {
		return (state: CommonState): LogoutCooldownLimitState | undefined => state.logoutCooldownLimit;
	}
}
